import { CreateQuizSelection, CreateQuizStep } from './create-quiz.models';

// Step stories add their entries here
export const CREATE_QUIZ_STEPS: CreateQuizStep[] = [];

// Step stories replace this with state they update
export const INITIAL_CREATE_QUIZ_SELECTION: CreateQuizSelection = {
  isQuestionBankRequired: false,
  topicIds: [],
};
